export const iresoftColors = {
    iresoftBlack: "#272727",
    iresoftRed: "#ce0b2d",
    transparent: "#0000",
    silver10025: "#bccbd740",
    black60: "#737373",
    white: "#fff",
    black: "#000c",
    sandybrown60: "#ffd4b4",
    blueviolet20: "#e2d6ff",
    black80: "#484848",
    black10: "#e6e6e6",
    blue100: "#7db7cd",
    brick100: "#ce7665",
    yellow100: "#fad87d",
    salmon100: "#e9aa8c",
    navy10010: "#5a66841a",
    iresoftDarkRed: "#900",
    navy100: "#5a6684",
    black40: "#a0a0a0",
    black20: "#cfcfcf",
};